import { EventType, SourcePages, Features } from 'lib/EventSchema';
import { EventData } from 'lib/EventLogger/Event';

const featuresTechnologyTypes: Record<string, string> = {
  backupCamera: 'backup_camera',
  bluetooth: 'bluetooth',
  entertainmentDVD: 'entertainment',
  handicapAccessible: 'handicap_accessible',
  iPodAUXInput: 'ipod_aux_input',
  laneDepartureWarning: 'lane_departure_warning',
  leather: 'leather',
  navigationSystem: 'navigation',
  roofRack: 'roof_rack',
  sunroofMoonroof: 'sun_moon_roof',
  '3rdRowSeats': 'third_row_seats',
  towing: 'towing',
  warranty: 'warranty',
};

export default function FeaturesTechnologyTapEvent(
  label: string,
  sourcePage: SourcePages
): EventData {
  return {
    event_type: EventType.engagement,
    source_page: sourcePage === SourcePages.Srp ? SourcePages.SrpFilter : SourcePages.SeoSrpFilter,
    feature: Features.featuresTechnology,
    engagement_type: `${featuresTechnologyTypes[label]}_tap`,
    event_context: {},
  };
}
